import locale from "@/assets/js/locale";

const requestHelper = {
  _getHeaders() {
    let headers = new Headers();
    headers.append('Accept', '*/*');

    return headers;
  },

  async apiGet(endpoint, credentials = null, params = {}) {
    let headers = this._getHeaders();

    headers.append('Accept-Language', locale.getLocale());
    
    if(endpoint.endsWith('/api/reports/stops')){
      headers.delete('Accept', '*/*');
      headers.append('Accept', 'application/json');
    }

    if (credentials !== null) {
      headers.append('Authorization', `Basic ${credentials}`);
    }

    if (params instanceof URLSearchParams) {
      endpoint += '?' + params.toString();
    }
    else if (Object.values(params).length > 0) {
      endpoint += '?' + (new URLSearchParams(params)).toString();
    }

    return fetch(endpoint, {
      method: 'GET',
      credentials: credentials !== null ? 'omit' : 'include',
      headers,
    });
  },

  async apiGetAnonymous(endpoint = null, params = {}) {
    let headers = this._getHeaders();

    if (params instanceof URLSearchParams) {
      endpoint += '?' + params.toString();
    }
    else if (Object.values(params).length > 0) {
      endpoint += '?' + (new URLSearchParams(params)).toString();
    }

    return fetch(endpoint, {
      method: 'GET',
      headers,
    });
  },

  async apiPost(endpoint, payload, credentials = null) {
    let headers = this._getHeaders();
    headers.append('Content-Type', 'application/json');

    if (credentials !== null) {
      headers.append('Authorization', `Basic ${credentials}`);
    }

    return fetch(endpoint, {
      method: 'POST',
      credentials: credentials !== null ? 'omit' : 'include',
      body: JSON.stringify(payload),
      headers,
    });
  },

  async apiPostAnonymous(endpoint, payload, queryParams = {}, headers = null) {
    if (!headers) {
      headers = headers ?? this._getHeaders();
      headers.append('Content-Type', 'application/json');
    }

    if (queryParams instanceof URLSearchParams) {
      endpoint += '?' + queryParams.toString();
    }
    else if (Object.values(queryParams).length > 0) {
      endpoint += '?' + (new URLSearchParams(queryParams)).toString();
    }

    return fetch(endpoint, {
      method: 'POST',
      body: JSON.stringify(payload),
      headers,
    });
  },

  async apiPostAsForm(endpoint, payload, credentials = null) {
    let headers = this._getHeaders();
    headers.append('Content-Type', 'application/x-www-form-urlencoded');

    if (credentials !== null) {
      headers.append('Authorization', `Basic ${credentials}`);
    }

    let formBody = [];

    for (let property in payload) {
      const encodedKey = encodeURIComponent(property);
      const encodedValue = encodeURIComponent(payload[property]);
      formBody.push(encodedKey + '=' + encodedValue);
    }

    formBody = formBody.join('&');

    return fetch(endpoint, {
      method: 'POST',
      credentials: credentials !== null ? 'omit' : 'include',
      headers,
      body: formBody,
    });
  },

  async apiPatch(endpoint, payload, credentials = null) {
    let headers = this._getHeaders();
    headers.append('Content-Type', 'application/json');

    if (credentials !== null) {
      headers.append('Authorization', `Basic ${credentials}`);
    }

    return fetch(endpoint, {
      method: 'PATCH',
      credentials: credentials !== null ? 'omit' : 'include',
      body: JSON.stringify(payload),
      headers,
    });
  },

  async apiPut(endpoint, payload, credentials = null) {
    let headers = this._getHeaders();
    headers.append('Content-Type', 'application/json');

    if (credentials !== null) {
      headers.append('Authorization', `Basic ${credentials}`);
    }

    return fetch(endpoint, {
      method: 'PUT',
      credentials: credentials !== null ? 'omit' : 'include',
      body: JSON.stringify(payload),
      headers,
    });
  },

  async apiDelete(endpoint, credentials = null) {
    let headers = this._getHeaders();

    if (credentials !== null) {
      headers.append('Authorization', `Basic ${credentials}`);
    }

    return fetch(endpoint, {
      method: 'DELETE',
      credentials: credentials !== null ? 'omit' : 'include',
      headers,
    });
  },
};

export default requestHelper;
